/**
 * Matador honeypot (`job-seeker`): clear value on submit unless the user actually
 * interacted with that input. Stops browser/password-manager autofill from tripping
 * matador\Honeypot::reject() while leaving bot POSTs (no JS / no our events) intact.
 */
(function() {
	'use strict';

	var HP = 'job-seeker';
	var MARK = 'evonaHpTouched';

	function isHoneypotInput(el) {
		return el && el.matches && el.matches('input[name="' + HP + '"]');
	}

	function markTouched(el) {
		if (isHoneypotInput(el)) {
			el.dataset[MARK] = '1';
		}
	}

	document.addEventListener('focusin', function(e) {
		markTouched(e.target);
	}, true);

	document.addEventListener('input', function(e) {
		markTouched(e.target);
	}, true);

	document.addEventListener('submit', function(e) {
		var form = e.target;
		if (!form || form.nodeName !== 'FORM' || form.id !== 'matador-application-form') {
			return;
		}
		var hp = form.querySelector('input[name="' + HP + '"]');
		if (!hp || hp.dataset[MARK] === '1') {
			return;
		}
		hp.value = '';
	}, true);
})();
